


































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import PaginateModel from "@/model/paginate";
import propertyApi from "@/api/propertyApi";
import postalCodeApi from "@/api/postalCodeApi";
import Property from "@/model/property";
import Location from "@/model/location";
import _ from "lodash";
import click2Top from "@/common/directives/click2Top";
import qNotify from "@/common/qNotify";
import store from "@/store";
import {namespace} from "vuex-class";
const routerStore = namespace("Router");
@Component({
  name: "PropertyList",
  directives: {
    click2Top,
  },
  components: {
    QPaginate,
    QTableHeader,
  },
})
export default class PropertyList extends Vue {
  @routerStore.Getter
  public getPreviousRouter;
  @routerStore.Getter
  public getSearchParameters;

  @Prop({
    default: () => {
      return {};
    },
  })
  query: Record<string, never>;
  public headers = [
    { id: "", name: "" },
    { id: "", name: "" },
    { id: "manage_number", name: "管理番号", order: "" },
    { id: "zip_code", name: "所在地", order: "asc" },
    { id: "name", name: "名称", order: "" },
    { id: "", name: "オーナー" },
    { id: "", name: "管理会社" },
    { id: "", name: "" },
  ];

  public search: any = {};

  public searchInital() {
    return {
      keyword: null,
      has_contract: null,
      move_out: null,
      prefecture: "",
      area: "",
      sort: "zip_code",
      direction: "asc",
    };
  }

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public properties: Property[] = null;
  public postalCode: Location[] = [];
  public propertySelected: string[] = [];
  get getPaginate() {
    return this.pagination;
  }
  get getArea() {
    this.search.prefecture;
    if (!this.search.prefecture) {
      return [];
    }
    return _.chain(this.postalCode)
      .filter((item) => item.prefecture === this.search.prefecture.trim())
      .uniqBy("area")
      .value();
  }
  get getPrefecture() {
    return _.uniqBy(this.postalCode, "prefecture");
  }
  public async floorList(query) {
    query = { ...query, ...this.query };
    const result = await propertyApi.index(query);
    this.pagination = result.paginate;
    this.properties = result.list;
  }

  mounted() {
    if( this.getPreviousRouter.matched[1] && this.getPreviousRouter.matched[1].name == "admin.property-router"
      && this.getSearchParameters && this.getSearchParameters.propertyList
    ) {
      this.search = this.getSearchParameters.propertyList;
    } else {
      this.initalSearch(null);
    }

    this.listPostalCode();

    this.floorList(this.search);
    // this.doSearch(this.search);
  }

  public async listPostalCode() {
    this.postalCode = await postalCodeApi.listOfProperty();
  }

  public clear() {
    this.search = this.searchInital();
    store.dispatch("Router/setSearchParameters", {propertyList: null});
    this.changeState();
    this.doSearch(this.search);
  }

  public doSearch(query: any): void {
    this.floorList(query);
  }

  public onSearch(): void {
    store.dispatch("Router/setSearchParameters", {propertyList: {...this.search}});
    this.changeState();
    this.doSearch(this.search);
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    this.search = {
      ...this.searchInital(),
      ...query,
    };
    if (Object.keys(query).length > 0) {
      store.dispatch("Router/setSearchParameters", {propertyList: this.search});
    } else {
      store.dispatch("Router/setSearchParameters", {propertyList: null});
    }
  }

  public bulkEdit() {
    if (this.propertySelected.length > 0) {
      store.dispatch("Property/setSelectedPropery", this.propertySelected);
      this.$router.push({
        name: "admin.property-bulk-edit",
      });
    } else {
      qNotify.error({
        text: this.$t("properties.must_be_a_property"),
      });
    }
  }
}
